import type { StoryType } from '@/features/publicsite/types/news/StoryType';

/**
 * The two values `type` may carry. Anything else in a hand-edited URL is dropped, not forwarded —
 * the endpoint answers an unknown enum with a 400, which would read here as an empty section.
 *
 * The same two are what a story page tells apart: an article says so under its date.
 */
export const STORY_TYPE = {
  news: 'NEWS',
  article: 'ARTICLE',
} as const;

/** Whether a value — from the URL, or from the server — is one of the two story types. */
export function isStoryType(value: string): value is StoryType {
  return Object.values<string>(STORY_TYPE).includes(value);
}
